<template>
    <Window ref="Window" @Close="myClose" >
    	<Confirm ref="confirm" @confirm="del"></Confirm>
      <!-- 头部开始 -->
   	     <div slot="head" class="pl1x pr1x bgWhite " >
        <div class='fs14x mb1x dpIB'>{{maintenanceDetail.name}}</div>
        <div class="cb">
            <ul class="dpIB_E fL_E">
                <li class="w25pct mb1x"><div class="cSub mb05x">{{getLanguageStr('plant233','维保人')}}:</div><div :title="maintenanceDetail.personNames?maintenanceDetail.personNames:'--'" class="curP">{{maintenanceDetail.personNames[0]}}{{$t('plant_detail93',[maintenanceDetail.personNames.length,'等x人'])}}</div></li>
                <li class="w25pct mb1x"><div class="cSub mb05x">{{getLanguageStr('word2003','维保时间')}}:</div><div>{{timeFormat(maintenanceDetail.time,'system','%Y/%m/%d %H:%M UTC')}}</div></li>
                <li class="w25pct mb1x"><div class="cSub mb05x">{{getLanguageStr('word1998','维保系统类型')}}:</div><div>{{maintenanceDetail.systemType?getTypeText(maintenanceDetail.systemType,'maintenanceSystem'):''}}</div></li>
                <li class="w25pct mb1x"><div class="cSub mb05x">{{getLanguageStr('word1999','维保系统')}}:</div><div>{{maintenanceDetail.systemTypeName?maintenanceDetail.systemTypeName:'--'}}</div></li>
               	<li class="w25pct mb1x"><div class="cSub mb05x">{{getLanguageStr('word2000','维保对象类型')}}:</div><div>{{maintenanceDetail.objectType?getTypeText(maintenanceDetail.objectType,'maintenanceObject'):''}}</div></li>
                 <li class="w25pct mb1x"><div class="cSub mb05x">{{getLanguageStr('word2001','维保对象')}}:</div>
                 	<div class="curP"  v-if="maintenanceDetail.objectType==1" :title="maintenanceDetail.deviceNameList">{{maintenanceDetail.deviceNameList[0]}}{{$t('app6',[maintenanceDetail.objectNameList.length,`等${maintenanceDetail.objectNameList.length}个设备`])}}</div>
					<div v-else :title="maintenanceDetail.objectNameList[0]" class="textCut w18x">{{maintenanceDetail.objectNameList[0]}}</div>
                 </li>
                 <li class="w25pct mb1x"><div class="cSub mb05x">{{getLanguageStr('app32','更新时间')}}:</div><div>{{timeFormat(maintenanceDetail.lastModifiedDate,'system','%Y/%m/%d %H:%M UTC')}}</div></li>
                 <li class="w25pct mb1x"><div class="cSub mb05x">{{getLanguageStr('word774','管理者')}}:</div><div>{{maintenanceDetail.createdByName}}</div></li>
                 <li class="w25pct mb1x"><div class="cSub mb05x">{{getLanguageStr('app2','创建时间')}}:</div><div>{{timeFormat(maintenanceDetail.createdDate,'system','%Y/%m/%d %H:%M UTC')}}</div></li>
            </ul>
        </div>
      </div>
      <div slot="headButton" class="dpIB fSub_E hover-f-main_E tra-fast_E">
      	<div slot="headButton" class="dpIB fSub_E hover-f-main_E tra-fast_E">
				<button class="hover-f-main fs12x" type="button" :title="$t('cmd8',['编辑'])"  @click="edit()" permission-type="none" v-permissions="'C/A/A7'"><Icon name="ico-edit-o" class="w1x h1x"/></button>
				<button type="button" :title="$t('cmd9',['删除'])" @click="confirmDel(maintenanceDetail.id)" permission-type="none" v-permissions="'C/A/A6'">
					<Icon name="ico-recycle" class="w1x h1x" :sizeBase="'m'"/>
				</button>
				<button :title="$t('cmd7',['刷新'])" type="button" @click="refresh"><Icon name="refresh" class="w1x h1x" :sizeBase="'m'" /></button>
		    </div>
      </div>
      <div fillHeight="lastHeight,-space" scroll>
        <div class="bgView ml1x mr1x mt1x" > 
            <div class="panel bgContent mc mb1x borderbox  h13x-min">
            	<div class="title title-bg">{{getLanguageStr('word2004','维保内容')}}</div>
                <div class="pt1x pr1x  ml1x mr1x imgW"><div v-html="maintenanceDetail.content" class="pb1x">{{maintenanceDetail.content}}</div></div>
            </div>
            <div class="panel bgContent mc mb1x borderbox h13x-min">
            	<div class="title title-bg">{{getLanguageStr('word1216','备注')}}</div>
            	<div class="pt1x pr1x  ml1x mr1x imgW"><div v-html="maintenanceDetail.remarks" class="pb1x">{{maintenanceDetail.remarks}}</div></div>
            </div>
        </div>
        </div>
    </Window>
</template>
<script>
import * as lib from '@/util/lib'
import Window from '@/components/common/ui/WindowForView.vue'
import {get,del} from '@/api/maintain/maintenance/list.js'
import Confirm from '@/components/common/ui/Confirm.vue'
export default {
  	name: 'viewdetail',
  	components: {
		    Window,
		    Confirm
  	},
	  props: {
	    bg: {
	      // 是否显示遮罩背景
	      type: Boolean,
	      default: false
	    }
	  },
  data () {
    return {
      id: '',
      open: false,
      maintenanceDetail:{
      	personNames:[],
      	objectNameList:[],
      	deviceNameList:[]
      },
    }
  },
  methods: {
  	getLanguageStr,
  	getTypeText: lib.getTypeText,
  	timeFormat: lib.timeFormat,
  			confirmDel(id){
	    		this.$refs.confirm.show({
		          text: getLanguageStr('app4', '确认要删除该维保记录吗？'),
		          id: id
	        	})
	   	},
	   		    del(data){
		    del(data.id).then(res => {
		    	   this.$refs.Window.hide()
		    		 this.$emit('refreshList');
			    }, error => {
			        !_.isEmpty(error) && this.$notify(error)
			})
	    },
    // 打开
    show (data) {
   //   this.maintenanceDetail=data;
      this.id=data.id;
      this.open = true
      this.$refs.Window.show()
      this.$nextTick(() => {   
      	this.get();
     	 this.$refs.Window.loadStatusAction(false)
      })
    },
        //获取详情
    get(){
    	this.$refs.Window.loadStatusAction(true)
    	get(this.id).then(res=>{
    		this.maintenanceDetail.deviceNameList=[]
        this.$refs.Window.loadStatusAction(false)
          this.maintenanceDetail =Object.assign({}, this.maintenanceDetail, res)
	        if(this.maintenanceDetail.objectType==1){
            if(	this.maintenanceDetail.deviceDetailList){
          this.maintenanceDetail.deviceDetailList.map((item,index)=>{
                    if(item.name!=null){
                      this.maintenanceDetail.deviceNameList[index]=item.name+item.serialNumber
                    }else{
                      this.maintenanceDetail.deviceNameList.push(this.getTypeText(item.type,'deviceType')+item.serialNumber)
                    //	this.$set(this.maintenanceDetail.deviceNameList,index,this.getTypeText(item.type,'deviceType')+item.serialNumber);
                    }
	        	})
            }
	        }
         this.$nextTick(()=>{
         	    lib.fillHeight()
    			lib.setScroll($(this.$el).find('[scroll]'))
         });
      },error=>{
          !_.isEmpty(error) && this.$notify(error)
      })
    },
    refresh () {
         this.get();
    },
    hide () {
      this.$refs.Window.hide()
    },
    edit(){
	      this.$parent.edit(this.maintenanceDetail)
    },
    myClose () {
      setTimeout(() => {
        this.open = false
      }, 500)
    }
  },
  mounted () {
    lib.fillHeight()
    lib.setScroll($(this.$el).find('[scroll]'))
  }
}
</script>
<style lang="scss" scoped>
.panel > .title{
	margin-bottom: 0;
}
.window > .body {
  padding-bottom: 0;
}
</style>
<style lang="scss">
	.imgW img{
	max-width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/view/application/maintenance/part/ViewDetail.vue